import PeriodDelta from './PeriodDelta';

export default PeriodDelta;

export type { IPeriodDeltaProps } from './PeriodDelta';
